import { useForm } from '@sequencehq/utils'
import {
  forAllInArray,
  isEmail,
  isUrl,
  required
} from '@sequencehq/utils/validation'
import {
  getNotificationTypesForChannel,
  NotificationPolicy,
  NotificationPolicyValidFormData
} from './nofitications.utils'
import { useState } from 'react'
import { Dashboardv99990101Api } from '@sequencehq/api/dashboard/v99990101'

type NotificationType = Dashboardv99990101Api.Notifications.NotificationType

export const useNotificationPolicySettings = (
  channel: 'EMAIL' | 'WEBHOOK',
  dunningEnabled: boolean,
  data?: NotificationPolicy | null
) => {
  const [showValidationErrors, setShowValidationErrors] = useState(false)

  const { fields, queries } = useForm({
    value: {
      name: data?.name,
      recipients: data?.recipients,
      notificationTypes: data?.notificationTypes?.length
        ? data?.notificationTypes
        : getNotificationTypesForChannel(channel, dunningEnabled)
    },
    showValidationErrors: showValidationErrors,
    fieldConfiguration: [
      {
        property: 'name',
        validation: [required]
      },
      {
        property: 'notificationTypes',
        validation: []
      },
      {
        property: 'recipients',
        validation: [
          forAllInArray({
            validator: channel === 'EMAIL' ? isEmail : isUrl,
            valueDescription: channel === 'EMAIL' ? 'email' : 'URL',
            permitEmptyArray: false,
            permitEmptyValue: false
          })
        ]
      }
    ]
  })

  const onSubmit = (
    handleSubmit: (formData: NotificationPolicyValidFormData) => void
  ) => {
    setShowValidationErrors(true)
    if (!queries.isValid) return
    handleSubmit(queries.formData as NotificationPolicyValidFormData)
  }

  const getSwitchFieldProps = (type: NotificationType) => ({
    isChecked: fields.notificationTypes.value?.includes(type),
    onChange: (value: boolean) => {
      const newValue = value
        ? [...fields.notificationTypes.value, type]
        : fields.notificationTypes.value?.filter(value => value !== type)

      fields.notificationTypes.onChange(newValue)
    }
  })

  return {
    fields,
    queries,
    onSubmit,
    getSwitchFieldProps
  }
}
